import { Schedule, Session } from '../models/Schedule';
import { Speaker } from '../models/Speaker';
import { Location } from '../models/Location';

import { Storage } from '@capacitor/storage';

import firebase from 'firebase/app';
import {firebaseConfig} from '../config/firebase.config';
import 'firebase/firestore';

  firebase.initializeApp(firebaseConfig);


const dataUrl = 'https://www.esimposio.com/miesimposio/appendpoints/?type=data&uid=123456';//https://esimposio.com/data.json
const locationsUrl = 'https://www.esimposio.com/miesimposio/appendpoints/?type=locations&uid=123456';

const HAS_LOGGED_IN = 'hasLoggedIn';
const HAS_SEEN_TUTORIAL = 'hasSeenTutorial';
const USERNAME = 'username';
const USERCED = 'userced';
const USERID = 'userid';
const USEROTHER = 'userother';
const FAVORITES = 'FAVORITOS';
let SCHEDULE_VERSION = "0";

export const getConfData = async () => {
  /*try {
    let responseSch = await fetch('https://esimposio.com/data.json');
    let responseJson = await responseSch.json();
    console.log(responseJson);
   } catch(error) {
    console.error(error);
  }*/
  
  //console.log(res);
  console.log("version antes:"+SCHEDULE_VERSION);
  const response = await Promise.all([
    fetch(dataUrl),
    fetch(locationsUrl)]);
  const responseData = await response[0].json();
  if(SCHEDULE_VERSION < responseData.version && SCHEDULE_VERSION != "0"){
    if (window.confirm('Se actualizará la aplicación')) {
      document.location.reload();
    }
  }
  SCHEDULE_VERSION = responseData.version;
  console.log("version ahora:"+SCHEDULE_VERSION);
  const schedule = responseData.schedule[0] as Schedule;
  const sessions = parseSessions(schedule);
  const speakers = responseData.speakers as Speaker[];
  const locations = await response[1].json() as Location[];
  const allTracks = sessions
    .reduce((all, session) => all.concat(session.tracks), [] as string[])
    .filter((trackName, index, array) => array.indexOf(trackName) === index)
    .sort();

  const data = {
    schedule,
    sessions,
    locations,
    speakers,
    allTracks,
    filteredTracks: [...allTracks]
  }
  return data;
}

export const getUserData = async () => {
  const response = await Promise.all([
    Storage.get({ key: HAS_LOGGED_IN }),
    Storage.get({ key: HAS_SEEN_TUTORIAL }),
    Storage.get({ key: SCHEDULE_VERSION }),
    Storage.get({ key: USERNAME }),
    Storage.get({ key: USERCED }),
    Storage.get({ key: USERID }),
    Storage.get({ key: USEROTHER }),
    Storage.get({ key: FAVORITES })]);
  //console.log(response);
  const isLoggedin = await response[0].value === 'true';
  const hasSeenTutorial = await response[1].value === 'true';
  const username = await response[3].value || undefined;
  const userced = await response[4].value || undefined;
  const userid = await response[5].value || undefined;
  const userother = await response[6].value || undefined;
  const favorites = await response[7].value || undefined;
  const res = await firebase.firestore().collection('favorites').where('userid', '==', userid).get();
  let infoFav = '';
  res.forEach((doc) =>{
    //console.log(doc.data());
    infoFav = infoFav+","+doc.data().sessionid;
  });
  await Storage.set({ key: "FAVORITOS", value: (infoFav).replace(/(^,)|(,$)/g, "") });
 

  //console.log(infoFav);
  const data = {
    isLoggedin,
    hasSeenTutorial,
    username,
    userced,
    userid,
    userother
  }
  return data;
}

export const setIsLoggedInData = async (isLoggedIn: boolean) => {
  await Storage.set({ key: HAS_LOGGED_IN, value: JSON.stringify(isLoggedIn) });
}

export const setHasSeenTutorialData = async (hasSeenTutorial: boolean) => {
  await Storage.set({ key: HAS_SEEN_TUTORIAL, value: JSON.stringify(hasSeenTutorial) });
}

export const setUsernameData = async (username?: string) => {
  if (!username) {
    await Storage.remove({ key: USERNAME });
  } else {
    await Storage.set({ key: USERNAME, value: username });
  }
}

export const setUserCedData = async (userced?: string) => {
  if (!userced) {
    await Storage.remove({ key: "USERCED" });
  } else {
    await Storage.set({ key: USERCED, value: userced });
  }
}

export const setUserIDData = async (userid?: string) => {
  if (!userid) {
    await Storage.remove({ key: USERID });
  } else {
    await Storage.set({ key: USERID, value: userid });
  }
}

export const setUserOtherData = async (userother?: string) => {
  if (!userother) {
    await Storage.remove({ key: USEROTHER });
  } else {
    await Storage.set({ key: USEROTHER, value: userother });
  }
}

function parseSessions(schedule: Schedule) {
  const sessions: Session[] = [];
  schedule.groups.forEach(g => {
    g.sessions.forEach(s => sessions.push(s))
  });
  return sessions;
}
